import { MeterCircleWebElementBase } from './MeterCircleWebElementBase';

/**
 * The component WebElement for [oj-c-meter-circle](../../jsdocs/oj-c.MeterCircle.html).
 * Do not instantiate this class directly, instead, use
 * [findMeterCircle](../functions/findMeterCircle.html).
 */
export class MeterCircleWebElement extends MeterCircleWebElementBase {
  // Put overrides here
}
